import { iterator } from '../symbol/iterator.js';
import { isFunction } from './isFunction.js';

function isIterable(input) {
    return isFunction(input === null || input === void 0 ? void 0 : input[iterator]);
}

export { isIterable };
//# sourceMappingURL=isIterable.js.map
